<script lang="ts">
  import { onMount } from 'svelte'
  import Flash from '#app/lib/components/flash.svelte'
  import { loadInternalLink } from '#app/lib/utils'
  import Spinner from '#components/spinner.svelte'
  import { formatReservationStartDate, getMyReservations, updateReservationState } from '#inventory/lib/reservations'

  let reservations = []
  let loading = true
  let cancellingReservationId = ''
  let flash

  onMount(async () => {
    try { reservations = await getMyReservations() } finally { loading = false }
  })

  async function cancel (reservation) {
    if (!confirm(`Annuler la réservation de « ${getTitle(reservation)} » à partir du ${formatReservationStartDate(reservation.month)} ?`)) return
    cancellingReservationId = reservation._id
    flash = null
    try {
      await updateReservationState({ reservation: reservation._id, state: 'cancelled' })
      reservations = reservations.filter(r => r._id !== reservation._id)
    } catch (err) {
      flash = err
    } finally {
      cancellingReservationId = ''
    }
  }

  async function confirmReceipt (reservation) {
    await updateReservationState({ reservation: reservation._id, state: 'received' })
    reservation.state = 'received'
    reservations = reservations
  }

  function getTitle (reservation) {
    return reservation.book?.title || 'Livre sans titre'
  }

  function getState (state) {
    return {
      reserved: 'Réservé',
      handed_over: 'Transmission confirmée',
      received: 'Livre reçu',
      completed: 'Terminé',
    }[state] || state
  }
</script>

<section class="reservations-page">
  <h1>Mes réservations</h1>
  <Flash state={flash} />
  {#if loading}
    <Spinner />
  {:else if reservations.length === 0}
    <p>Aucune réservation.</p>
  {:else}
    <ul>
      {#each reservations as reservation}
        <li>
          <div class="book">
            <a href={`/items/${reservation.item}`} on:click={loadInternalLink}>{getTitle(reservation)}</a>
            {#if reservation.book?.authors}<span>{reservation.book.authors}</span>{/if}
          </div>
          <strong>À partir du {formatReservationStartDate(reservation.month)}</strong>
          <span>{getState(reservation.state)}</span>
          {#if reservation.message}<span class="message">« {reservation.message} »</span>{/if}
          {#if reservation.state === 'reserved'}
            <button
              disabled={cancellingReservationId === reservation._id}
              on:click={() => cancel(reservation)}
            >
              {cancellingReservationId === reservation._id ? 'Annulation…' : 'Annuler ma réservation'}
            </button>
          {:else if reservation.state === 'handed_over'}
            <button on:click={() => confirmReceipt(reservation)}>J’ai reçu le livre</button>
          {/if}
        </li>
      {/each}
    </ul>
  {/if}
</section>

<style>
  .reservations-page { max-width: 50rem; margin: 2rem auto; padding: 1rem; }
  li { display: flex; flex-wrap: wrap; gap: 1rem; align-items: center; padding: 0.75rem 0; border-bottom: 1px solid #ddd; }
  .book { display: flex; flex: 1 1 18rem; flex-direction: column; }
  .book a { font-weight: bold; }
  .book span { color: #777; }
  .message { flex: 1 1 100%; color: #666; font-style: italic; }
  button { margin-left: auto; }
</style>
